export const COACH_DASHBOARD_TABLE_COLUMN_WIDTHS = Object.freeze({
  client: 20,
  block: 12,
  week: 11,
  workouts: 39,
  status: 12,
  actions: 6,
});

export const COACH_DASHBOARD_TABLE_COLUMN_ORDER = Object.freeze([
  "client",
  "block",
  "week",
  "workouts",
  "status",
  "actions",
]);

export const getCoachDashboardTableColumnWidth = (columnKey) => {
  const width = COACH_DASHBOARD_TABLE_COLUMN_WIDTHS[columnKey];
  if (!Number.isFinite(width)) return "0%";
  return `${width}%`;
};

export const getCoachDashboardTableTotalWidth = () =>
  COACH_DASHBOARD_TABLE_COLUMN_ORDER.reduce((total, columnKey) => {
    const width = COACH_DASHBOARD_TABLE_COLUMN_WIDTHS[columnKey];
    return total + (Number.isFinite(width) ? width : 0);
  }, 0);
